import { Client } from "./client";
import { 
  TestMethodAssignmentListResponse, 
  TestMethodAssignmentResponse,
  CreateTestMethodAssignmentRequest
} from "@/backend/express/controllers/requirements/requirementsController";
import { FusaReply } from "@/types/replyTypes";

export class RequirementTestMethodAssignmentFrontendController {
  client: Client;

  constructor() {
    this.client = new Client();
  }

  getAssignmentsByRequirementId(requirementId: string): Promise<TestMethodAssignmentListResponse> {
    return this.client.read(`/api/requirements/${requirementId}/test-method-assignments`);
  }

  async createAssignment(requirementId: string, data: CreateTestMethodAssignmentRequest): Promise<TestMethodAssignmentResponse> {
    return this.client.create(`/api/requirements/${requirementId}/test-method-assignments`, data);
  }

  async deleteAssignment(requirementId: string, assignmentId: string): Promise<FusaReply> {
    return this.client.delete(`/api/requirements/${requirementId}/test-method-assignments/${assignmentId}`);
  }
}
